module.exports = __webpack_public_path__ + "img/img-6.febd7378.jpg";